/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Refreshpage1Inputs */

const en_btn_refreshpage1 = /** @type {(inputs: Btn_Refreshpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh page`)
};

/**
* | output |
* | --- |
* | "Refresh page" |
*
* @param {Btn_Refreshpage1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_refreshpage1 = /** @type {((inputs?: Btn_Refreshpage1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Refreshpage1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_refreshpage1(inputs)
});
export { btn_refreshpage1 as "btn_refreshPage" }